import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from "@contentful/rich-text-types";

import './TextSection.scss';
const TextSection = ({ title, bodyText }) => {


    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };
    return (
        <section className="text-section">
            {/* {title && <h2>{title}</h2>} */}
            <div className="body">{documentToReactComponents(bodyText, renderOptions)}</div>
        </section>
    );
};

export default TextSection; 